export class Timeout {
	private timeout: ReturnType<typeof setTimeout> | undefined
	private timeoutLength: number
	private callback: () => void

	constructor(onTimeout: () => void, timeoutLength: number) {
		this.timeoutLength = timeoutLength
		this.callback = onTimeout
	}

	private onTimeout = () => {
		clearTimeout(this.timeout)
		this.callback()
	}

	start = () => {
		if (this.timeout) clearTimeout(this.timeout)
		this.timeout = setTimeout(this.onTimeout, this.timeoutLength)
	}

	stop = () => {
		if (this.timeout) clearTimeout(this.timeout)
	}
}
